import { Button, ButtonStyle } from '@cluey/cluey-components';
import classNames from 'classnames';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { generatePath, useHistory } from 'react-router-dom';

import { Enrolment } from '../../../api/types/enrolment';
import { useSelectEnrolmentModal } from '../../../components/Modals/SelectEnrolmentModal/SelectEnrolmentModal';
import { getActiveEnrolments } from '../../../selectors/hubSelector';
import { PATH_HUB_ADD_ONE_OFF_SESSION } from '../../../util/pagePath';

export interface BookOneOffSessionProps {
  buttonClassName?: string;
  buttonText?: string;
  buttonAppearance?: ButtonStyle;
}

export const BookOneOffSession = ({
  buttonClassName,
  buttonText = 'Book a make-up session',
  buttonAppearance = 'solid',
}: BookOneOffSessionProps) => {
  const history = useHistory();
  const activeEnrolments: Array<Enrolment> = useSelector(getActiveEnrolments);
  const { open, openModal, closeModal, SelectEnrolmentModal } = useSelectEnrolmentModal();

  const handleBookSession = useCallback(() => {
    if (activeEnrolments.length === 1) {
      const enrolmentId = activeEnrolments[0].enrolmentId;
      history.push(
        generatePath(PATH_HUB_ADD_ONE_OFF_SESSION, {
          enrolmentId,
        })
      );
    } else {
      openModal();
    }
  }, [activeEnrolments, history, openModal]);

  return (
    <>
      <Button
        type="button"
        size="sm"
        appearance={buttonAppearance}
        className={classNames('rounded-full', buttonClassName)}
        onClick={handleBookSession}
      >
        {buttonText}
      </Button>
      <SelectEnrolmentModal
        position="top"
        open={open}
        closeModal={closeModal}
        enrolmentLinkTo={(enrolment) => {
          return generatePath(PATH_HUB_ADD_ONE_OFF_SESSION, {
            enrolmentId: enrolment.enrolmentId,
          });
        }}
        subtitle="Which enrolment do you need to book a make-up session for?"
        filterEnrolmentType="Course"
      />
    </>
  );
};
